import React, { useEffect } from 'react';
import { Flex, ThemeProvider } from 'pcln-design-system';
import { SinglePinIcon } from './SinglePinIcon';
import { SinglePinLabel } from './SinglePinLabel';
import styled from 'styled-components';
import { getMapPinOnClickHandler } from './getMapPinOnClickHandler';
const StyledFlex = /*#__PURE__*/styled(Flex).withConfig({
  displayName: "MapPinElement__StyledFlex",
  componentId: "sc-12ekb-0"
})([":hover{cursor:pointer;}"]);
export const MapPinElement = props => {
  const domRef = React.useRef(null);
  domRef.current = props.markerDOM;
  useEffect(() => {
    if (domRef.current) {
      domRef.current.addListener('click', event => {
        const handler = getMapPinOnClickHandler(props);
        handler(event);
      });
    }
  }, []);
  return React.createElement(ThemeProvider, null, React.createElement(StyledFlex, {
    alignItems: 'center',
    style: {
      transform: 'translateX(50%)'
    }
  }, React.createElement(SinglePinIcon, Object.assign({}, props)), React.createElement(SinglePinLabel, Object.assign({}, props))));
};